import React from 'react';
import './Heritage.css';

const Heritage = () => {
  return (
    <section className="heritage-banner">
      <div className="heritage-content">
        <h2 className="heritage-title">Experience Mega Genie Excellence</h2>
        <p className="heritage-text">
          Discover premium quality products curated for your lifestyle. Where style meets affordability.
        </p>
        <button className="btn-secondary">Learn More About Us</button>
      </div>
    </section>
  );
};

export default Heritage;
